<template>
  <div class="content">
    <div style="position: fixed;right:10px;top:300px;z-index:1000">
      <Rightnav @showsp="getshow" @runtops="runtop"></Rightnav>
    </div>
    <transition name="slide-fade">
      <div class="Mask" v-if="showquote">
        <div class="mask-main">
          <i @click="mask" class="iconfont icon-guanbi"></i>
          <Freequote></Freequote>
        </div>
      </div>
    </transition>
    <div class="banane">
      <img src="../assets/images/nav_img1.jpg" />
    </div>
    <div class="main">
      <div class="Science-select">
        <div class="Science-btn">
          <div class="Science-title">预算</div>
          <el-radio
            @change="budgets(item)"
            v-for="(item,index) in budget"
            :key="index"
            :label="item.name"
            v-model="radio1"
          ></el-radio>
        </div>
        <div class="Science-btn">
          <div class="Science-title">风格</div>
          <div class="pinas">
            <el-radio
              @change="stylesp(item)"
              v-for="(item,index) in styles"
              :key="index"
              :label="item.style"
              v-model="radio2"
            >{{item.style}}</el-radio>
          </div>
        </div>
        <div class="Science-btn">
          <div class="Science-title">户型</div>
          <el-radio
            @change="Apartments(item)"
            v-for="(item,index) in Apartment"
            :key="index"
            :label="item.name"
            v-model="radio3"
          ></el-radio>
        </div>
        <div class="Science-btn">
          <div class="Science-title">面积</div>
          <el-radio
            @change="measures(item)"
            v-for="(item,index) in measure"
            :key="index"
            :label="item.name"
            v-model="radio4"
          ></el-radio>
        </div>
      </div>
      <div class="product-main">
        <Tpicker @citydata="getcitydata" :cidatas="posdata"></Tpicker>
        <ul>
          <li @click="todetailsde(item.docid)" v-for="(item,index) in datas.list" :key="index">
            <div class="bran-father">
            <img :src="item.mainpicmax" oncontextmenu="return false;"/>
            <div class="brand" >桔家云</div>
            </div>
            <div class="liname">
              {{item.roomnum}}{{item.meetnum}}{{item.toiletnum}}
              <br />
              <span style="font-size: 15px;">{{item.cnaddress}}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="page">
      <el-pagination
        :page-size="20"
        background
        :current-page.sync="page"
        @current-change="handlecurrentchange"
        layout="prev, pager, next"
        :total="datas.totalCount">
        </el-pagination>
    </div>
    <div>
      <BottomFoot> </BottomFoot>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import BottomFoot from "../components/BottomFoot.vue";
import Rightnav from "../components/Rightnav.vue";
import Freequote from "../components/Freequote.vue";
import Tpicker from "../components/Tpicker.vue";
export default {
  components: {
    BottomFoot,
    Rightnav,
    Freequote,
    Tpicker
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "description",
          content:
            "桔家云、装修案例、装修参考、整装、婚房、单身公寓、装修效果图、100平、三口之家、儿童房桔家云整装，上千个装修案例实景分享，业主精心总结装修攻略，新中式、简欧、美式等各种风格案例，尽在桔家云整装。"
        }
      ]
    };
  },
  data() {
    return {
      showquote: false,
      topnub: 0,
      nub: "3",
      budget: [
        { name: "全部" },
        { name: "3万以下" },
        { name: "3万-5万" },
        { name: "5-10万" },
        { name: "15-20万" },
        { name: "20万以上" }
      ],
      styles: [],
      Apartment: [
        { name: "全部" },
        { name: "小户型" },
        { name: "一居室" },
        { name: "二居室" },
        { name: "三居室" },
        { name: "四房" },
        { name: "公寓" },
        { name: "复式" },
        { name: "别墅" },
        { name: "跃层" }
      ],
      measure: [
        { name: "全部" },
        { name: "40-60平米" },
        { name: "70-90平米" },
        { name: "100-120平米" },
        { name: "130-150平米" },
        { name: "150平米以上" }
      ],
      current: 0,
      checkList: [],
      //预算
      radio1: "全部",
      //风格
      radio2: "全部",
      //户型
      radio3: "全部",
      //面积
      radio4: "全部",
      posdata: "",
      page: 1,
      datas: ""
    };
  },
  methods: {
    addClass(index, item) {
      this.current = index;
    },
    getshow(data) {
      // console.log("data", data);
      this.showquote = data;
    },
    mask() {
      this.showquote = false;
    },
    runtop(data) {
      document.documentElement.scrollTop = data;
    },
    getpositions(data) {
      // console.log('datass',data);
      this.posdata = data;
      this.getdata();
    },
    getcitydata(data) {
      // console.log('getcitydata',data);
      this.posdata.province = data[0];
      this.posdata.city = data[1];
      this.posdata.area = data[2];
      this.getdata();
    },
    handlecurrentchange(size) {
      this.page = size;
      // this.postcs();
    },
    budgets(item) {
      this.getdata();
    },
    stylesp() {
      this.getdata();
    },
    Apartments() {
      this.getdata();
    },
    measures() {
      this.getdata();
    },
    stylesl: async function() {
      let res = await this.exequy.style();
      // console.log('res',res);
      this.styles = res.data.data;
      this.styles.unshift({ id: 100, style: "全部" });
      this.getdata()
    },
    getdata: async function() {
      let data = {
        province: this.posdata.province,
        city: this.posdata.city,
        area: this.posdata.area,
        page: this.page,
        limit: 15,
        plantype: this.radio1,
        style: this.radio2,
        roomtype: this.radio3,
        areatype: this.radio4
      };
      let res = await this.exequy.Packagescreening(data);
      this.datas = res.data.page;
    },
    todetailsde(item) {
      this.$router.push({ path: "/Decorationdetails", query: { id: item } });
    }
  },
  created: async function() {
    let self = this;
    self.stylesl();
  }
};
</script>
<style scoped>
.content {
  width: 100%;
}
.head {
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 1000;
}
.main {
  width: 1340px;
  margin: 0 auto;
}
.banane {
  width: 100%;
  height: 340px;
  
}
.banane img {
  width: 100%;
  height: 100%;
}
.classred {
  color: #b31d25;
}
.Science-select {
  width: 100%;
  margin-top: 1.4rem;
}
.Science-title {
  width: 8%;
  height: 3rem;
  line-height: 3rem;
  float: left;
  text-align: center;
  background: #f3f3f3;
}
.Science-btn {
  width: 100%;
  height: 3rem;
  border-bottom: 1px solid #f7f1f1;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.Science-btn ul {
  overflow: hidden;
  padding-inline-start: 0px;
  color: #666;
}
.Science-btn ul li {
  list-style: none;
  width: 80px;
  height: 33px;
  float: left;
  line-height: 33px;
  border-radius: 8px;
  text-align: left;
}
.bran-father{
  position: relative;
  height: 280px;
}
.brand{
 width:85px; 
 height:40px; 
 background:#b31d25;
 position:absolute;
 top: 0px;
 right: 0px;
 color: #fff;
 line-height: 40px;
 font-size: 19px;
}
.Science-btn >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #b31d25;
}
.Science-btn >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #b31d25;
  border-color: #b31d25;
}
.product-main {
  width: 100%;
}
.product-main ul {
  overflow: hidden;
  padding-inline-start: 0px;
  margin-left: -3%;
}
.product-main ul li {
  list-style: none;
  width: 30.3%;
  height: 345px;
  float: left;
  margin-left: 3%;
  cursor: pointer;
}
.product-main ul li img {
  width: 100%;
  height:100%;
}
.el-button--default {
  width: 100%;
  background: #b31d25;
  border: 0px;
  color: #fff;
}
.Mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
}
.mask-main {
  border-radius: 15px;
  text-align: center;
  width: 50%;
  height: 60%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  background-color: white;
  z-index: 10000;
}
.icon-guanbi {
  font-size: 25px;
  position: absolute;
  right: 11px;
  top: 5px;
  line-height: normal;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.Science-btn >>> .el-radio__inner {
  display: none;
}
.Science-btn >>> .el-radio__input.is-checked + .el-radio__label {
  color: #b31d25;
}
.Science-btn >>> .el-radio__label {
  margin-left: 30px;
}
.liname {
  font-size: 16px;
  line-height: 25px;
  text-align: left;
  color: #827c7c;
}
.page {
  margin-bottom: 15px; 
}
</style>
